'use client'

import { useParams } from 'next/navigation'

import { redirectToPortal } from '../components/Layout/utils/redirectToPortal'
import { isPortalAppOnClient } from '../utils/isPortalApp'

import { usePollEmailVerification } from './usePollEmailVerification'

export function useRefreshEmailVerification() {
  const { locale } = useParams()

  const { isChecking } = usePollEmailVerification({
    onVerified: () => {
      if (!isPortalAppOnClient()) {
        redirectToPortal('', typeof locale === 'string' ? locale : 'en')
      }
    },
  })

  return { isChecking, error: false }
}
